import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Globe2, List } from 'lucide-react';
import { searchPageStyles } from './SearchPage.styles';
import { SEARCH_TYPE_LABELS } from './SearchPage.constants';
import { localePathPrefix } from '../../utils/localeRouting';
import { trackUserAction } from '../../utils/analytics';

const WebSearchCard = ({ 
  currentSearchType, 
  aiFullScreen, 
  aiOverviewVisible, 
  aiResponseType, 
  searchResultsRef, 
  gcsLoaded, 
  handleNewSearch 
}) => {
  const location = useLocation();
  const prefix = localePathPrefix(location.pathname);
  const lessonsTo = `${prefix}/topics`;
  const worldsTo = `${prefix}/topics/explorer`;

  return (
    <div
      className="web-search-card"
      style={{
        ...searchPageStyles.webSearchCard,
        display: aiFullScreen ? 'none' : undefined,
        flex: aiOverviewVisible ? (aiResponseType === 'direct_response' ? 1 : 'none') : 1,
        minWidth:
          aiOverviewVisible && aiResponseType === 'direct_response'
            ? 320
            : '100%',
        maxWidth: aiOverviewVisible ? (aiResponseType === 'direct_response' ? 420 : '100%') : '100%',
        width: '100%',
        position: aiOverviewVisible
          ? (aiResponseType === 'direct_response' ? 'sticky' : 'static')
          : 'static',
        top: aiOverviewVisible ? (aiResponseType === 'direct_response' ? 120 : 'auto') : 'auto',
        alignSelf: aiOverviewVisible
          ? (aiResponseType === 'direct_response' ? 'flex-start' : 'stretch')
          : 'stretch',
        height: aiOverviewVisible ? (aiResponseType === 'direct_response' ? 'fit-content' : 'auto') : 'auto',
        order: aiOverviewVisible ? (aiResponseType === 'direct_response' ? 2 : 1) : 1,
        opacity: aiFullScreen ? 0 : 1,
        pointerEvents: aiFullScreen ? 'none' : 'auto',
        zIndex: aiFullScreen ? 1 : 'auto',
        left: 0,
        right: 0,
        margin: aiFullScreen ? '0 auto' : undefined,
        visibility: aiFullScreen ? 'hidden' : 'visible',
      }}
    >
      <div style={searchPageStyles.webSearchHeader}>
        <div style={searchPageStyles.webSearchIcon}>
          <span style={{ fontSize: 16, color: 'var(--color-bg-card)' }}>🔍</span>
        </div>
        <div>
          <h3 style={searchPageStyles.webSearchTitle}>
            {SEARCH_TYPE_LABELS[currentSearchType] || 'Web'} Search Results
          </h3>
          <p style={searchPageStyles.webSearchSubtitle}>
            Web search results (supervised use recommended)
          </p>
        </div>
      </div>

      <div
        style={{
          margin: '0 20px 16px',
          padding: '12px 14px',
          borderRadius: 14,
          background: 'var(--color-bg)',
          border: '1px solid var(--color-border)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          flexWrap: 'wrap',
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: 14,
            lineHeight: 1.45,
            color: 'var(--color-text)',
            opacity: 0.88,
            flex: '1 1 200px',
          }}
        >
          Prefer guided lessons? Open the lesson index, or pick a world for paths — Animals, Robotics,
          Math, and more.
        </p>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 10,
            flexShrink: 0,
            alignItems: 'center',
          }}
        >
          <Link
            to={lessonsTo}
            onClick={() => trackUserAction.navigationClick('search_lesson_index')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 16px',
              borderRadius: 12,
              border: '1px solid var(--color-border)',
              background: 'var(--color-bg)',
              color: 'var(--color-text)',
              fontWeight: 700,
              fontSize: 14,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              minHeight: 44,
              boxSizing: 'border-box',
            }}
          >
            <List size={18} strokeWidth={2.2} aria-hidden />
            Lesson index
          </Link>
          <Link
            to={worldsTo}
            onClick={() => trackUserAction.navigationClick('search_explore_topics')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 16px',
              borderRadius: 12,
              background: 'var(--color-primary)',
              color: '#fff',
              fontWeight: 700,
              fontSize: 14,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              minHeight: 44,
              boxSizing: 'border-box',
            }}
          >
            <Globe2 size={18} strokeWidth={2.2} aria-hidden />
            Explore worlds
          </Link>
        </div>
      </div>

      {/* Google CSE Results Container */}
      <div
        className="gcse-searchresults"
        id="web-search-results-root"
        ref={searchResultsRef}
        data-noresultsstring="No results found. Try adjusting your search terms."
        data-safesearch="active"
        data-enableautocomplete="true"
        data-enableorderby="true"
        style={{ minHeight: 200, padding: '0 20px 20px 20px' }}
      ></div>
    </div>
  );
};

export default WebSearchCard; 